export default __webpack_public_path__ + "static/media/test-logo.9771d9ed.svg";